module.exports = __webpack_public_path__ + "img/03.2ac16841.png";